export function isCallback(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}